import { styled } from './styled';

export const Pre = styled('pre', {
	fontFamily: '$mono',
	padding: '$8 $0',
	fontSize: '$4',
	borderTop: '1px solid',
	borderBottom: '1px solid',
	borderColor: '$mono30',
	whiteSpace: 'pre-wrap',
	md: {
		padding: '$8 0',
		fontSize: '$4s',
	},
});
